export const sections = ['O NAS', 'PRODUKCIJE', 'POSEBNE PONUDBE', 'ŽIVI ODER']  



// WEBPACK FOOTER //
// ./src/utils/variables.js